import React, { useEffect, useState } from "react";
import LiveChatReplyField from "./LiveChatReplyField";
import { ReactComponent as LikeIcon } from "../../../assets/Icons/like.svg";
import { ReactComponent as ReplyIcon } from "../../../assets/Icons/reply.svg";
import { ReactComponent as FlagIcon } from "../../../assets/Icons/flag.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/Icons/delete.svg";
import LiveChatCommentReplies from './LiveChatCommentReplies';
import initializeFirebase from '../../../firebaseConfig';
import Translate from "../../../Components/Multilanguage/Translate";
import { increment, onValue, push, ref, set, update } from "firebase/database";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getCurrentUTCTimestamp, timeDifferenceWithCurrenttime } from "../../../utils/utils";

if (!window.__liveChatUserCache) window.__liveChatUserCache = {};
const userCache = window.__liveChatUserCache;

const LiveChatCommentItem = ({ data, projectInfo, isEvent = false, onReply, hideReplyAction = false, onMediaLoad, onDeleted }) => {
  const firebaseDB = initializeFirebase(projectInfo);
  const user = useSelector((state) => state?.user?.value);
  const [isReplyField, setIsReplyField] = useState(false);
  const [childReplyField, setChildReplyField] = useState(false);
  const [showReplies, setShowReplies] = useState(hideReplyAction);
  const [replies, setReplies] = useState([]);
  const [liked, setLiked] = useState(false);
  const [commentedUser, setIsCommentedUser] = useState(() => userCache[data?.user_id] || {});
  const [commentedTime, setcommentedTime] = useState("");
  const theme = projectInfo?.projectConfig?.config?.THEME;

  useEffect(() => {
    const firebaseDB = initializeFirebase(projectInfo);
    const usersDbRef = ref(firebaseDB, `users/${data?.user_id}`);
    commentsReplyListing();
    userHasLiked();
    if (userCache[data?.user_id]) {
      setIsCommentedUser(userCache[data?.user_id]);
    } else {
      onValue(usersDbRef, (snapshot) => {
        const val = snapshot.val();
        if (val) userCache[data?.user_id] = val;
        setIsCommentedUser(val);
      }, { onlyOnce: true });
    }
    setcommentedTime(timeDifferenceWithCurrenttime(data?.created_at));
    let timedifferenceCalculation = setInterval(() => {
      setcommentedTime(timeDifferenceWithCurrenttime(data?.created_at));
    }, 20 * 1000);
    return () => clearInterval(timedifferenceCalculation);
  }, [data]);

  useEffect(() => {
    const commentElements = document.querySelectorAll('.eachComment');
    commentElements.forEach((el) => {
      if (theme === 'LIGHT') {
        el.style.setProperty('--white-color', '#000000');
        el.style.setProperty('--inner-text-color', '#555555');
      } else {
        el.style.setProperty('--white-color', '#ffffff');
        el.style.setProperty('--inner-text-color', '#cccccc');
      }
    });
    return () => {
      commentElements.forEach((el) => {
        el.style.removeProperty('--white-color');
        el.style.removeProperty('--inner-text-color');
      });
    };
  }, [theme]);

  const childReplyFieldHandler = (childFlag) => {
    setChildReplyField(childFlag);
  };

  const mainReplyFieldHandler = () => {
    if (!childReplyField) {
      setIsReplyField((prev) => !prev);
    }
  };

  const userHasLiked = async () => {
    if (data?.liked_users && data?.liked_users[user]) {
      setLiked(true);
    } else {
      setLiked(false);
    }
  };

  const commentsReplyListing = () => {
    const replyArray = [];
    for (let key in data?.replies) {
      if (data?.replies.hasOwnProperty(key)) {
        replyArray.push({ ...data.replies[key], replyId: key });
      }
    }
    setReplies(replyArray.filter((item) => item?.delete_status !== true));
  };

  const likeHandler = () => {
    const dbRef = ref(firebaseDB, `comments/${isEvent ? 'event-' : ''}${data?.videoId}/${data?.id}`);
    const dbRefLikedUsers = ref(firebaseDB, `comments/${isEvent ? 'event-' : ''}${data?.videoId}/${data?.id}/liked_users/${user}`);
    update(dbRef, { likes: increment(liked ? -1 : 1) });
    set(dbRefLikedUsers, liked ? 0 : 1);
  };

  const reportHandler = () => {
    if (userHasReported() === false) {
      const dbRef = ref(firebaseDB, `comments/${isEvent ? 'event-' : ''}${data?.videoId}/${data?.id}`);
      const dbRefReportedUsers = ref(firebaseDB, `comments/${isEvent ? 'event-' : ''}${data?.videoId}/${data?.id}/reported_users/${user}`);
      update(dbRef, { reported_count: increment(1) });
      set(dbRefReportedUsers, 1);
      toast.success(<Translate textKey={'successfully_reported'} />, { position: "top-center" });
    } else {
      toast.error(<Translate textKey={'already_reported'} />, { position: "top-center" });
    }
  };

  const userHasReported = () => {
    return !!(data?.reported_users && data?.reported_users[user]);
  };

  const deleteCommentHandler = () => {
    const dbRef = ref(firebaseDB, `comments/${isEvent ? 'event-' : ''}${data?.videoId}/${data?.id}`);
    update(dbRef, { delete_status: true, deleted_at: getCurrentUTCTimestamp() });
    toast.success(<Translate textKey={'comment_deleted_successfully'} />, { position: 'top-center' });
    if (onDeleted) onDeleted();
  };

  const linkify = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.split(urlPattern).filter(Boolean).map((part, index) =>
      urlPattern.test(part)
        ? <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>{part}</a>
        : part
    );
  };

  return (
    <div className="eachComment">
      <div className="containers">
        <div className="commentItem">
          <div className="left">
            {commentedUser?.image ? (
              <div className="profileImageContainer">
                <img src={commentedUser?.image} alt="Profile" />
              </div>
            ) : (
              <span className="nameAvatar">{commentedUser?.name?.slice(0, 1)?.toUpperCase()}</span>
            )}
          </div>
          <div className="right">
            <div className="nameTimeRow">
              <h1 className="name">{commentedUser?.name}</h1>
              <span className="time">{commentedTime}</span>
            </div>
            {data.comment_text && <p className="comment">{linkify(data.comment_text)}</p>}
            {data.image?.url && (
              <div className="comment-image-container">
                <img src={data.image?.url} alt="Comment" onLoad={() => { if (onMediaLoad) onMediaLoad(); }} />
              </div>
            )}
            <div className="actions">
              <span className="item" onClick={likeHandler}>
                <span className="icon">
                  <LikeIcon style={liked ? { fill: "red" } : {}} />
                </span>
                {data?.likes > 0 && data?.likes} {data?.likes >= 2 ? <Translate textKey={'likes'} /> : <Translate textKey={'like'} />}
              </span>
              {!hideReplyAction && (
              <span className="item" onClick={() => {
                if (onReply) {
                  onReply(data, commentedUser?.name || 'user');
                } else if (!childReplyField) {
                  setIsReplyField((prev) => !prev);
                }
              }}>
                <span className="icon"><ReplyIcon /></span>
                <Translate textKey={'reply'} />
              </span>
              )}
              {data?.user_id === Number(user) ? (
                <span className="item" onClick={() => deleteCommentHandler()}>
                  <span className="icon"><DeleteIcon /></span>
                  <Translate textKey={'delete'} />
                </span>
              ) : (
                <span className="item" onClick={() => reportHandler()}>
                  <span className="icon"><FlagIcon /></span>
                  <Translate textKey={'report'} />
                </span>
              )}
            </div>
            {replies.length > 0 && (
              <span
                className="viewRepliesBtn"
                onClick={() => setShowReplies((prev) => !prev)}
              >
                {showReplies
                  ? <><ReplyIcon /> <Translate textKey={'hide_replies'} /></>
                  : <><ReplyIcon /> <Translate textKey={'view'} /> {replies.length} {replies.length === 1 ? <Translate textKey={'reply'} /> : <Translate textKey={'replies'} />}</>
                }
              </span>
            )}
            {showReplies && replies.map((item) => (
              <LiveChatCommentReplies
                key={item.replyId}
                reply={item}
                parentComment={data}
                isEvent={isEvent}
                projectInfo={projectInfo}
                openParentReplyField={() => setIsReplyField(true)}
                onMediaLoad={onMediaLoad}
              />
            ))}
          </div>
        </div>
        {isReplyField && (
          <LiveChatReplyField
            isEvent={isEvent}
            setIsReplyField={setIsReplyField}
            data={data}
            childReplyFieldHandler={childReplyFieldHandler}
            projectInfo={projectInfo}
          />
        )}
      </div>
    </div>
  );
};

export default LiveChatCommentItem;
